import { useQuery } from "@tanstack/react-query";
import { getWallet } from "../api";
import type { WalletBalance } from "../api";

export const walletKeys = {
  balance: ["wallet", "balance"] as const,
  transactions: (cursor?: string) => ["wallet", "transactions", cursor] as const,
  ledger: (cursor?: string) => ["wallet", "ledger", cursor] as const,
};

export function useWallet() {
  return useQuery<WalletBalance>({
    queryKey: walletKeys.balance,
    queryFn: getWallet,
    staleTime: 30_000,
  });
}
